module.exports = __webpack_public_path__ + "static/media/img_logo_S.d823172f.svg";